import {gql} from "@apollo/client";

import {ResponseStatus, ServerErrors} from "@/lib/types/common.ts";
import {ExternalUser} from "@/lib/types/statuspages.ts";

export interface ExternalUsersPageResult {
  externalUsers: {
    items: ExternalUser[];
    total: number;
  };
}

export const GQL_EXTERNAL_USERS = gql`
  query ExternalUsers($statusPageID: Int!, $offset: Int, $limit: Int, $sort: String, $search: String) {
    externalUsers(statusPageID: $statusPageID, offset: $offset, limit: $limit, sort: $sort, search: $search) {
      items {
        id
        first_name
        last_name
        email
        is_active
      }
      total
    }
  }
`;

export interface UpdateExternalUserResponse {
  response: {
    status: ResponseStatus;
    message: ServerErrors;
  };
}

export const GQL_EXTERNAL_USER_UPDATE = gql`
  mutation UpdateExternalUser($statusPageID: Int!, $data: ExternalUserInput!) {
    response: updateExternalUser(statusPageID: $statusPageID, data: $data) {
      ... on BaseResponse {
        status
      }
      ... on ErrorResponse {
        status
        message
      }
    }
  }
`;

export const GQL_EXTERNAL_USER_TOGGLE = gql`
  mutation ToggleExternalUser($statusPageID: Int!, $userId: Int!) {
    response: toggleExternalUserAccess(statusPageID: $statusPageID, userId: $userId) {
      ... on BaseResponse {
        status
      }
      ... on ErrorResponse {
        status
        message
      }
    }
  }
`;

export const GQL_EXTERNAL_USERS_DELETE = gql`
  mutation DeleteEUAccess($statusPageID: Int!, $userIds: [Int!]!) {
    response: deleteExternalUsersAccess(statusPageID: $statusPageID, userIds: $userIds) {
      ... on BaseResponse {
        status
      }
      ... on ErrorResponse {
        status
        message
      }
    }
  }
`;

export const GQL_EXTERNAL_USER_RESET_PASSWORD = gql`
  mutation ResetEUPassword($statusPageID: Int!, $userId: Int!) {
    response: resetExternalUserPassword(statusPageID: $statusPageID, userId: $userId) {
      ... on BaseResponse {
        status
      }
      ... on ErrorResponse {
        status
        message
      }
    }
  }
`;
